import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#F7941D" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink target="_blank" href="https://www.facebook.com/Minori-Sushi-Restaurant-137390939609357/">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Minori Sushi Facebook"
              />
            </CFLink>
            {/* <CFLink href="https://www.zomato.com/vancouver/minori-sushi-restaurant-north-delta">
              <CFImage w="40px" pr="10px" src={yelp} alt="Minori Sushi Yelp" />
            </CFLink> */}
            <CFLink target="_blank" href="https://www.zomato.com/vancouver/minori-sushi-restaurant-north-delta">
              <CFImage
                w="40px"
                pr="10px"
                src={zomato}
                alt="Minori Sushi Zomato"
              />
            </CFLink>
            <CFLink target="_blank" href="https://www.instagram.com/minori_sushi_delta/?hl=en">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Minori Sushi Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#F7941D" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink target="_blank" href="https://www.facebook.com/Minori-Sushi-Restaurant-137390939609357/">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Minori Sushi Facebook"
                hover
              />
            </CFLink>
            {/* <CFLink href="https://www.yelp.ca/biz/88-palpal-noodle-house-burnaby">
              <CFImage
                w="40px"
                pr="10px"
                src={yelp}
                alt="Minori Sushi Yelp"
                hover
              />
            </CFLink>  */}
            <CFLink target="_blank" href="https://www.zomato.com/vancouver/minori-sushi-restaurant-north-delta">
              <CFImage
                w="40px"
                pr="10px"
                src={zomato}
                alt="Minori Sushi Zomato"
                hover
              />
            </CFLink>
            <CFLink target="_blank" href="https://www.instagram.com/minori_sushi_delta/?hl=en">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Minori Sushi Instagram"
                hover
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
